import { ImageRequirements } from '../services/imageService';

export const EVENT_COVER_REQUIREMENTS: ImageRequirements = {
  maxSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  dimensions: {
    minWidth: 1200,
    maxWidth: 4096,
    minHeight: 630,
    maxHeight: 4096,
    aspectRatio: 1.91 // Facebook recommended aspect ratio (1200x630)
  }
};

export const EVENT_GALLERY_REQUIREMENTS: ImageRequirements = {
  maxSize: 8 * 1024 * 1024, // 8MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  dimensions: {
    minWidth: 800,
    maxWidth: 4096,
    minHeight: 600,
    maxHeight: 4096
  }
};

export const PROFILE_PHOTO_REQUIREMENTS: ImageRequirements = {
  maxSize: 2 * 1024 * 1024, // 2MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  dimensions: {
    minWidth: 400,
    maxWidth: 2048,
    minHeight: 400,
    maxHeight: 2048,
    aspectRatio: 1 // Square
  }
};

export const ORGANIZER_LOGO_REQUIREMENTS: ImageRequirements = {
  maxSize: 2 * 1024 * 1024, // 2MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  dimensions: {
    minWidth: 400,
    maxWidth: 2048,
    minHeight: 400,
    maxHeight: 2048,
    aspectRatio: 1 // Square
  }
};

export const VENUE_PHOTO_REQUIREMENTS: ImageRequirements = {
  maxSize: 8 * 1024 * 1024, // 8MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  dimensions: {
    minWidth: 1000,
    maxWidth: 4096,
    minHeight: 750,
    maxHeight: 4096,
    aspectRatio: 4 / 3
  }
}; 